import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/intelligence-engines/page.tsx");
